import { group_list } from "pages/Finance/Transaction/utils";

export const getGroupCardLabel = (group_card: number) => {
  return (
    group_list.find((item) => item.value === group_card.toString())?.label ?? ""
  );
};
